import React, { Component } from 'react';
import './Filter.css';

export default class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: [
        { name: 'Alle' },
        { name: 'Vorspeise' },
        { name: 'Hauptspeise' },
        { name: 'Nachspeise' },
        { name: 'Sonstiges' }
      ],
      active: 'Alle'
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    let index = e.target.value;
    let name = this.state.filter[index].name;
    this.setState({ active: name });
    this.props.onClick(name);
  }

  render() {
    return (
      <div className="filter">
        <strong>Filtern</strong>
        <select name="filter" id="filter" onChange={this.onChange}>
          {this.state.filter.map((option, ind) => (
            <option className="item" key={ind} value={ind}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    );
  }
}
